export default __webpack_public_path__ + "static/media/login_logo.4e0ca2c4.png";